export default __webpack_public_path__ + "static/media/chaoslabs.ceb9aaaf.svg";